export default __webpack_public_path__ + "static/ab95d28c-a889-4a51-9888-bf05d972de13-e50ccefbe6978b6ef14118196cba2cce.woff";